import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { OrderDetailsContextValue } from './orderDetailsContext.types';

export type { OrderDetailsContextValue } from './orderDetailsContext.types';

const OrderDetailsContext = createContext<OrderDetailsContextValue | null>(
  null,
);

export function OrderDetailsProvider({
  children,
  value,
}: Readonly<{
  children: ReactNode;
  value: OrderDetailsContextValue;
}>) {
  return (
    <OrderDetailsContext.Provider value={value}>
      {children}
    </OrderDetailsContext.Provider>
  );
}

export function useOrderDetailsContext(): OrderDetailsContextValue {
  const value = useContext(OrderDetailsContext);
  if (!value) {
    throw new Error(
      'useOrderDetailsContext must be used within OrderDetailsProvider',
    );
  }
  return value;
}
